/* 26.09.2026: переклад через Translate & Adapt. ADL("текст") повертає переклад
   з window.ADAPTIS_L (snippets/adaptis-l.liquid, ключі locales/uk.json
   adaptis_js.*), а без перекладу той самий український текст. */
var ADL = window.ADL || (window.ADL = function(s){ return window.ADAPTIS_L ? window.ADAPTIS_L(s) : s; });
/**
 * Adaptis Quick Buy Drawer
 * Логіка: відкриття drawer, завантаження варіантів, додавання в кошик
 */

(function () {
  'use strict';

  // ─── DOM refs ───────────────────────────────────────────────────────────────
  const overlay    = document.getElementById('quick-buy-overlay');
  const drawer     = document.getElementById('quick-buy-drawer');
  const closeBtn   = document.getElementById('qb-close-btn');
  const loading    = document.getElementById('qb-loading');
  const content    = document.getElementById('qb-content');
  const optionsEl  = document.getElementById('qb-options');
  const variantInp = document.getElementById('qb-variant-id');
  const submitBtn  = document.getElementById('qb-submit-btn');
  const unavailMsg = document.getElementById('qb-unavailable');
  const titleEl    = document.getElementById('qb-product-title');
  const priceEl    = document.getElementById('qb-product-price');
  const imageEl    = document.getElementById('qb-product-image');

  if (!drawer) return; // snippet not loaded

  // ─── State ──────────────────────────────────────────────────────────────────
  let productData     = null;
  let selectedOptions = [];
  let parentProductId = null;
  /* 25.09.2026: код фарби для «В колір авто». */
  let paintCode = '';
  const isPaint = v => /premium|авто/i.test(String(v || ''));
  let paintIndex = -1;

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
  /* 25.09.2026: як на решті сайту: 7 200 ₴. */
  return Math.round((cents || 0) / 100).toLocaleString('uk-UA').replace(/[\s\u00a0\u202f]/g, ' ') + ' ₴';
}

  function findVariant() {
    if (!productData) return null;
    return productData.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    ) || null;
  }

  function showLoading() {
    loading.removeAttribute('aria-hidden');
    content.setAttribute('aria-hidden', 'true');
    loading.style.display = 'flex';
    content.style.display = 'none';
  }

  function showContent() {
    loading.setAttribute('aria-hidden', 'true');
    content.removeAttribute('aria-hidden');
    loading.style.display = 'none';
    content.style.display = 'block';
  }

  /* 25.09.2026: після додавання показуємо те саме вікно «Додано в кошик», що
     й на сторінках товару (AdaptisCartPop з adaptis-configurator.js). На
     сторінках без конструктора файли вантажимо, коли відкривається вікно. */
  let popLoading = null;
  /* 28.09.2026: чекаємо і скрипт, і стилі вікна: без стилів воно на мить
     зʼявлялось би голим текстом. */
  function ensurePop() {
    if (window.AdaptisCartPop) return Promise.resolve(window.AdaptisCartPop);
    if (popLoading) return popLoading;
    const a = window.ADAPTIS_POP_ASSETS;
    if (!a) return Promise.resolve(null);
    const css = new Promise(resolve => {
      let l = document.querySelector('link[data-adaptis-pop]') || [...document.querySelectorAll('link[rel="stylesheet"]')].find(x => x.href && x.href.indexOf('adaptis-configurator.css') > -1);
      if (l && l.sheet) return resolve();
      if (!l) {
        l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = a.css; l.dataset.adaptisPop = '1';
        document.head.appendChild(l);
      }
      l.addEventListener('load', () => resolve(), { once: true });
      l.addEventListener('error', () => resolve(), { once: true });
      setTimeout(resolve, 3000);
    });
    const js = new Promise(resolve => {
      const sc = document.createElement('script');
      sc.src = a.js; sc.async = true;
      sc.onload = () => resolve(window.AdaptisCartPop || null);
      sc.onerror = () => resolve(null);
      document.head.appendChild(sc);
    });
    popLoading = Promise.all([js, css]).then(r => r[0]);
    return popLoading;
  }
  /* 26.09.2026: курсор завантаження на всій сторінці, поки товар додається і
     відкривається «Додано в кошик». Тайм-аут на випадок, якщо вікно не відкрилось. */
  let busyT = 0;
  function pageBusy(on) {
    const h = document.documentElement;
    clearTimeout(busyT);
    h.classList.toggle('adaptis-busy', !!on);
    if (on) busyT = setTimeout(() => h.classList.remove('adaptis-busy'), 8000);
  }
  /* 28.09.2026: x = {adding, preview, onOpen, onFail}. З adding (запит
     додавання) вікно відкривається одразу, ще до відповіді Shopify
     (AdaptisCartPop.open), onOpen кличеться в ту ж мить, onShown коли кошик
     готовий, onFail коли Shopify відмовив. Без adding як раніше: товар уже
     додано, вікно відкривається з готовим кошиком. */
  function showAdded(productId, handle, onShown, x) {
    x = x || {};
    pageBusy(true);
    const opened = () => { pageBusy(false); if (typeof x.onOpen === 'function') x.onOpen(); };
    const done = () => { pageBusy(false); if (typeof onShown === 'function') onShown(); };
    const failed = err => { pageBusy(false); if (typeof x.onFail === 'function') x.onFail(err); };
    const noPop = () => {
      if (!x.adding) { updateCartCount(); done(); return false; }
      x.adding.then(() => { updateCartCount(); opened(); done(); }, failed);
      return false;
    };
    return ensurePop().then(CP => {
      if (!CP) return noPop();
      const o = { productId: String(productId || ''), productHandle: handle || null, onShown: () => { const c = CP.cart; if (c) CP.announce(c); updateCartCount(c); done(); } };
      if (x.adding) Object.assign(o, { adding: x.adding, preview: x.preview || [], onOpen: opened, onFail: failed });
      else CP.cart = null;
      CP.open(o);
      return true;
    }).catch(noPop);
  }
  /* 25.09.2026: «Разом із цим купують» тягнемо заздалегідь, щоб вікно
     «Додано в кошик» відкривалось одразу. */
  function prefetchFor(productId, handle) {
    return ensurePop().then(CP => CP && CP.prefetch ? CP.prefetch({ productId: String(productId || ''), productHandle: handle || null }) : null).catch(() => null);
  }
  /* Файли вікна вантажимо, щойно сторінка з картками вільна (лише там, де є миша). */
  if (document.querySelector('.adaptis-card__atc') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const idle = window.requestIdleCallback || (f => setTimeout(f, 1500));
    idle(() => ensurePop(), { timeout: 3000 });
  }

  // ─── Open / Close ────────────────────────────────────────────────────────────

  function openDrawer() {
    drawer.hidden = false; overlay.hidden = false;
    drawer.removeAttribute('aria-hidden');
    overlay.removeAttribute('aria-hidden');
    /* Щойно показане вікно спершу розкладаємо (offsetWidth), потім додаємо
       клас: так поява плавна, і не треба чекати кадру (у фоновій вкладці
       requestAnimationFrame не спрацьовує). */
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    /* 28.09.2026: прокрутку блокуємо на html, не на body: інакше липкі
       фільтри каталогу відлітали вгору, поки вікно відкрите. */
    document.documentElement.style.overflow = 'hidden';
    // Focus close button for accessibility
    setTimeout(() => closeBtn.focus(), 300);
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    productData = null;
  }

  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // ─── Load product data ───────────────────────────────────────────────────────

  /* 25.09.2026: дані товару запамʼятовуємо, повторне відкриття без запиту. */
  const productCache = {};
  async function loadProduct(handle) {
  if (productCache[handle]) return productCache[handle];
   let rootPath = '/';
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    rootPath = window.Shopify.routes.root;
  } else if (window.Shopify && window.Shopify.locale) {
     const locale = window.Shopify.locale;
    if (locale !== 'uk' && locale !== 'ru' && locale !== 'en') {
     }
  }

   if (!rootPath.endsWith('/')) rootPath += '/';
 
  const res = await fetch(`${rootPath}products/${handle}.js`);
  
  if (!res.ok) {
    console.error('QuickBuy error: Product not found at', `${rootPath}products/${handle}.js`);
    throw new Error('Product not found');
  }
  
  const data = await res.json();
  productCache[handle] = data;
  return data;
}

  // ─── Render options ──────────────────────────────────────────────────────────

  /* 25.09.2026: колір кружечками, «Призначення» перемикачем, решта кнопками
     (стилі в snippets/quick-buy-drawer.liquid). Кольори ті самі, що в
     даних конструктора. */
  function hexOf(val) {
    const v = String(val || '').toLowerCase();
    if (v.includes('чорн')) return '#1F2220';
    if (v.includes('сір')) return '#7D827C';
    if (v.includes('олив')) return '#4A5335';
    if (v.includes('син')) return '#1F4E9C';
    if (v.includes('авто') || v.includes('premium')) return 'conic-gradient(from 210deg, #e34b4b, #e3a34b, #dfe34b, #6fe34b, #4be3c0, #4b8fe3, #7a4be3, #e34bc8, #e34b4b)';
    if (v.includes('біл')) return '#E7E8E3';
    return null;
  }
  /* 25.09.2026: іконки моделей Starlink (ті самі, що на картках каталогу) і
     поділ складеної опції «Колір (Модель)» на два рівні (чохол Adaptis). */
  const MI = {mini:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/mini_5ae44135-0b97-4afe-b85e-6af07c84e371.svg?v=1772912622", gen2:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/gen2_1a5dc09f-4b69-4e0b-b697-18452cd619fc.svg?v=1772912622", gen3:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/gen3_9cc2fc01-8564-4d10-bb8f-7a668e8e2338.svg?v=1772912622", performance:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/performance.svg?v=1772912622"};
  const modelIcon = (t) =>{ t = String(t || "").toLowerCase(); if (/performance/.test(t)) return MI.performance; if (/gen\s*2/.test(t)) return MI.gen2; if (/gen\s*3|4x|standard/.test(t)) return MI.gen3; if (/mini/.test(t)) return MI.mini; return null; };
  const COMPOUND = /^(.+?)\s*\(([^)]+)\)\s*$/;
  function variantFor(testOptions) {
    return productData.variants.find(v => v.options.every((opt, i) => opt === testOptions[i]));
  }

  function renderOptions() {
    optionsEl.innerHTML = '';

    /* 25.09.2026: «Ціна для Сил Оборони України» завжди над вибором кольору,
       як на сторінці товару: опцію «Призначення» малюємо першою. */
    const optNameOf = o => String(o && typeof o === 'object' ? (o.name || o.value || '') : (o || '')).toLowerCase();
    const order = productData.options.map((o, i) => i).sort((a, b) => (optNameOf(productData.options[b]).includes('призначен') ? 1 : 0) - (optNameOf(productData.options[a]).includes('призначен') ? 1 : 0));
    order.forEach(optionIndex => {
      const optionName = productData.options[optionIndex];
      // All possible values for this option
      const values = [...new Set(productData.variants.map(v => v.options[optionIndex]))];
      const nameStr = String(optionName && typeof optionName === 'object' ? (optionName.name || optionName.value || '') : (optionName || ''));
      const nameLc = nameStr.toLowerCase();
      if (values.length < 2) return;
      /* Призначення: перемикач «Ціна для Сил Оборони України». */
      const defVal = values.find(v => /Оборон/.test(v));
      if (nameLc.includes('призначен') && defVal && values.length === 2) {
        const civVal = values.find(v => v !== defVal);
        const lab = document.createElement('label');
        lab.className = 'qb-tgl';
        lab.innerHTML = ("<input type=\"checkbox\"><span class=\"qb-tgl__b\"></span><span>" + ADL("Ціна для Сил Оборони України") + "</span>");
        const cb = lab.querySelector('input');
        cb.checked = selectedOptions[optionIndex] === defVal;
        cb.addEventListener('change', () => {
          const want = cb.checked ? defVal : civVal;
          const test = [...selectedOptions]; test[optionIndex] = want;
          const mv = variantFor(test) || productData.variants.find(v => v.options[optionIndex] === want && v.available);
          if (mv) selectedOptions = [...mv.options]; else selectedOptions[optionIndex] = want;
          renderOptions();
          updateSubmitState();
        });
        optionsEl.appendChild(lab);
        return;
      }
      /* Колір: кружечки, якщо всі кольори відомі. */
      /* Назва опції буває й англійською («Color», G2kit і набори). */
      if ((nameLc.includes('колір') || nameLc.includes('color')) && values.every(v => hexOf(v))) {
        const group = document.createElement('div');
        group.className = 'qb-option-group';
        const title = (nameLc.includes('корпус') || nameLc.includes('color')) ? ADL('Колір корпусу') : nameStr;
        group.innerHTML = '<p class="qb-option-label"><span class="qb-t"></span>: <span class="qb-option-selected-value"></span></p><div class="qb-sws"></div>';
        group.querySelector('.qb-t').textContent = title;
        const lbl = v => /premium/i.test(v) ? ADL('В колір авто') : v;
        group.querySelector('.qb-option-selected-value').textContent = lbl(selectedOptions[optionIndex] || '');
        const row = group.querySelector('.qb-sws');
        values.forEach(value => {
          const test = [...selectedOptions]; test[optionIndex] = value;
          const mv = variantFor(test);
          const ok = mv ? mv.available : false;
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'qb-sw' + (selectedOptions[optionIndex] === value ? ' is-selected' : '') + (!ok ? ' is-unavailable' : '');
          b.setAttribute('aria-label', lbl(value)); b.title = lbl(value);
          b.innerHTML = '<span></span>';
          b.querySelector('span').style.background = hexOf(value);
          if (!ok) b.disabled = true;
          b.addEventListener('click', () => { selectedOptions[optionIndex] = value; renderOptions(); updateSubmitState(); });
          row.appendChild(b);
        });
        paintIndex = values.some(isPaint) ? optionIndex : paintIndex;
        /* «В колір авто»: поле для коду фарби, тексти ті самі, що в квізі. */
        if (isPaint(selectedOptions[optionIndex])) {
          /* 26.09.2026: доплата за фарбування окремим рядком (власник): різниця
             з тим самим варіантом у звичайному кольорі, тож і для Сил Оборони правильна. */
          const plain = values.find(v => !isPaint(v));
          const tp = [...selectedOptions], tb = [...selectedOptions]; tb[optionIndex] = plain;
          const vp = variantFor(tp), vb = plain ? variantFor(tb) : null;
          if (vp && vb && vp.price > vb.price) {
            const fee = document.createElement('p');
            fee.className = 'qb-paintfee';
            fee.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:12px 16px;margin:14px 0 0;border-radius:16px;background:#eff3f7;font-size:15px;line-height:1.4;font-weight:500;color:#0e0e0e';
            fee.innerHTML = ("<span>" + ADL("Фарбування в колір авто") + "</span><b style=\"white-space:nowrap;font-weight:600\"></b>");
            fee.querySelector('b').textContent = '+ ' + formatMoney(vp.price - vb.price);
            group.appendChild(fee);
          }
          const f = document.createElement('label');
          f.className = 'qb-paint';
          f.innerHTML = ("<span class=\"qb-paint__l\">" + ADL("Код кольору кузова, якщо знаєте") + "</span>") +
            ("<input type=\"text\" maxlength=\"40\" autocomplete=\"off\" placeholder=\"" + ADL("Наприклад, 040 або NH731P").replace(/"/g, "&quot;") + "\">") +
            ("<span class=\"qb-paint__h\">" + ADL("Фарбуємо корпус у колір вашого авто. Код є в сервісній книжці або на табличці під капотом. Якщо не знаєте, залиште це поле порожнім.") + "</span>");
          const inp = f.querySelector('input');
          inp.value = paintCode;
          inp.addEventListener('input', () => { paintCode = inp.value; });
          group.appendChild(f);
        }
        optionsEl.appendChild(group);
        return;
      }

      const group = document.createElement('div');
      group.className = 'qb-option-group';

      const labelEl = document.createElement('p');
      labelEl.className = 'qb-option-label';
      const optionNameStr = optionName && typeof optionName === 'object'
        ? (optionName.name || optionName.value || ('Option ' + (optionIndex + 1)))
        : String(optionName || '');
      const selectedVal = selectedOptions[optionIndex] || '';
      labelEl.innerHTML = optionNameStr + ': <span class="qb-option-selected-value">' + selectedVal + '</span>';

      /* Складена опція «Мультикам (Mini)»: колір кружечками з візерунком (центр
         фото варіанта) і корпус кнопками з іконками. Дані в каталозі ті самі. */
      const cm = values.map(v => String(v).match(COMPOUND));
      const cCols = [...new Set(cm.filter(Boolean).map(m => m[1].trim()))];
      const cMods = [...new Set(cm.filter(Boolean).map(m => m[2].trim()))];
      if (cm.every(Boolean) && cCols.length > 1 && cMods.length > 1) {
        const valOf = (c, m) => values.find(v => String(v).match(COMPOUND)[1].trim() === c && String(v).match(COMPOUND)[2].trim() === m);
        const curM = String(selectedOptions[optionIndex] || '').match(COMPOUND) || [null, cCols[0], cMods[0]];
        const curCol = curM[1].trim(), curMod = curM[2].trim();
        const pickVal = (v) => { if (!v) return; selectedOptions[optionIndex] = v; renderOptions(); updateSubmitState(); };
        const okVal = (v) => { if (!v) return false; const t = [...selectedOptions]; t[optionIndex] = v; const mv = variantFor(t); return !!(mv && mv.available); };
        /* 26.09.2026: візерунок кольору завжди з фото Gen3 (далі Gen2), як на
           сторінці товару: фото Mini в каталозі повернуті й дрібніші. */
        const swMod = cMods.find(m => /gen\s*3|4x|standard/i.test(m)) || cMods.find(m => /gen\s*2/i.test(m)) || curMod;
        const swVal = (c) => valOf(c, swMod) || valOf(c, curMod) || valOf(c, cMods[0]) || values.find(y => String(y).indexOf(c) === 0);
        const imgOf = (c) => { const v = productData.variants.find(x => x.options[optionIndex] === swVal(c)); const src = v && v.featured_image && (v.featured_image.src || v.featured_image); return src ? String(src) + (String(src).indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; };
        const g1 = document.createElement('div');
        g1.className = 'qb-option-group';
        g1.innerHTML = ("<p class=\"qb-option-label\">" + ADL("Колір:") + " <span class=\"qb-option-selected-value\"></span></p><div class=\"qb-sws\"></div>");
        g1.querySelector('.qb-option-selected-value').textContent = curCol;
        cCols.forEach(c => {
          const v = valOf(c, curMod) || cm.map((m, k) => m[1].trim() === c ? values[k] : null).find(Boolean);
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'qb-sw qb-sw--img' + (c === curCol ? ' is-selected' : '') + (!okVal(v) ? ' is-unavailable' : '');
          b.title = c; b.setAttribute('aria-label', c);
          b.innerHTML = '<span></span>';
          const im = imgOf(c);
          if (im) b.querySelector('span').style.backgroundImage = 'url("' + im + '")';
          /* 26.09.2026: фото варіантів Mini повернуті на 90° відносно Gen2 і Gen3,
             тож візерунок із них повертаємо праворуч. */
          const sv = String(swVal(c) || '').match(COMPOUND);
          if (sv && /mini/i.test(sv[2])) b.classList.add('qb-sw--rot');
          if (!okVal(v)) b.disabled = true;
          b.addEventListener('click', () => pickVal(v));
          g1.querySelector('.qb-sws').appendChild(b);
        });
        optionsEl.appendChild(g1);
        const g2 = document.createElement('div');
        g2.className = 'qb-option-group';
        g2.innerHTML = '<p class="qb-option-label"></p><div class="qb-option-pills"></div>';
        g2.querySelector('.qb-option-label').textContent = optionNameStr;
        cMods.forEach(m => {
          const v = valOf(curCol, m) || cm.map((x, k) => x[2].trim() === m ? values[k] : null).find(Boolean);
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'qb-pill' + (m === curMod ? ' is-selected' : '') + (!okVal(v) ? ' is-unavailable' : '');
          const ic = modelIcon(m);
          b.innerHTML = (ic ? '<span class="qb-mi" aria-hidden="true"></span>' : '') + '<span></span>';
          /* 26.09.2026: іконка маскою кольору тексту: на обраній кнопці синя. */
          if (ic) b.querySelector('.qb-mi').style.setProperty('--mi', 'url("' + ic + '")');
          b.lastChild.textContent = m;
          if (!okVal(v)) b.disabled = true;
          b.addEventListener('click', () => pickVal(v));
          g2.querySelector('.qb-option-pills').appendChild(b);
        });
        optionsEl.appendChild(g2);
        return;
      }

      /* 25.09.2026: як на сторінці товару: більше 6 значень або довгі значення
         (довжини кабелю) випадним списком, решта кнопками. */
      const maxLen = Math.max(...values.map(v => String(v).length));
      /* 25.09.2026: довгі значення до 6 штук (довжини кабелю) картками з
         довжиною і ціною, щоб ціну було видно до вибору. Більше 6 списком. */
      if (maxLen > 26 && values.length <= 6) {
        labelEl.textContent = optionNameStr;
        const list = document.createElement('div');
        list.className = 'qb-cards';
        const short = v => { const m = String(v).match(/(\d+(?:[.,]\d+)?)\s*(?:m|м)\b/i); return m ? m[1] + (" " + ADL("м")) : v; };
        values.forEach(value => {
          const test = [...selectedOptions]; test[optionIndex] = value;
          const mv = variantFor(test);
          const ok = !!(mv && mv.available);
          const c = document.createElement('button');
          c.type = 'button';
          c.className = 'qb-card' + (selectedOptions[optionIndex] === value ? ' is-selected' : '');
          c.setAttribute('aria-pressed', String(selectedOptions[optionIndex] === value));
          c.title = value;
          c.innerHTML = '<span class="qb-card__t"></span><span class="qb-card__p"></span>';
          c.querySelector('.qb-card__t').textContent = short(value);
          c.querySelector('.qb-card__p').textContent = mv ? formatMoney(mv.price) : '';
          if (!ok) c.disabled = true;
          c.addEventListener('click', () => { selectedOptions[optionIndex] = value; renderOptions(); updateSubmitState(); });
          list.appendChild(c);
        });
        group.appendChild(labelEl);
        group.appendChild(list);
        optionsEl.appendChild(group);
        return;
      }
      if (values.length > 6 || maxLen > 26) {
        labelEl.textContent = optionNameStr;
        const wrap = document.createElement('span');
        wrap.className = 'qb-select';
        const sel = document.createElement('select');
        sel.setAttribute('aria-label', optionNameStr);
        values.forEach(value => {
          const test = [...selectedOptions]; test[optionIndex] = value;
          const mv = variantFor(test);
          const o = document.createElement('option');
          o.value = value; o.textContent = value;
          if (!(mv && mv.available)) o.disabled = true;
          if (selectedOptions[optionIndex] === value) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', () => { selectedOptions[optionIndex] = sel.value; renderOptions(); updateSubmitState(); });
        wrap.appendChild(sel);
        wrap.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9L12 15L18 9"/></svg>');
        group.appendChild(labelEl);
        group.appendChild(wrap);
        optionsEl.appendChild(group);
        return;
      }

      const pills = document.createElement('div');
      pills.className = 'qb-option-pills';

      values.forEach(value => {
        // Is this value available given the other currently-selected options?
        const testOptions = [...selectedOptions];
        testOptions[optionIndex] = value;
        const matchingVariant = productData.variants.find(v =>
          v.options.every((opt, i) => opt === testOptions[i])
        );
        const isAvailable = matchingVariant ? matchingVariant.available : false;
        const isSelected  = selectedOptions[optionIndex] === value;

        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'qb-pill' +
          (isSelected   ? ' is-selected'   : '') +
          (!isAvailable ? ' is-unavailable' : '');
        pill.textContent = value;
        /* Іконка моделі Starlink поруч із назвою (Mini, Mini X, Standard 4X). */
        const pic = (nameLc.includes('модель') || nameLc.includes('корпус')) ? modelIcon(value) : null;
        if (pic) { pill.innerHTML = '<span class="qb-mi" aria-hidden="true"></span><span></span>'; pill.querySelector('.qb-mi').style.setProperty('--mi', 'url("' + pic + '")'); pill.lastChild.textContent = value; }
        pill.dataset.optionIndex = optionIndex;
        pill.dataset.value = value;
        if (!isAvailable) pill.disabled = true;

        pill.addEventListener('click', () => {
          selectedOptions[optionIndex] = value;
          renderOptions();
          updateSubmitState();
        });

        pills.appendChild(pill);
      });

      group.appendChild(labelEl);
      group.appendChild(pills);
      optionsEl.appendChild(group);
    });
  }

  function updateSubmitState() {
  const variant = findVariant();
  variantInp.value = variant ? variant.id : '';

  // Обновляем цену выбранного варианта
  if (variant && priceEl) {
    priceEl.textContent = formatMoney(variant.price);
  }

  if (!variant) {
    unavailMsg.style.display = 'block';
    submitBtn.disabled = true;
  } else if (!variant.available) {
    unavailMsg.style.display = 'block';
    submitBtn.disabled = true;
  } else {
    unavailMsg.style.display = 'none';
    submitBtn.disabled = false;
  }

  setSubmitText('default');
}

  // ─── Init drawer with product ─────────────────────────────────────────────

  /* 28.09.2026: via = {src, ev}, коли вікно відкрите з допродажу у вікні
     «Додано в кошик»: позиція й подія рахуються як допродаж, а не швидка
     покупка. */
  let quickVia = null;
  async function initDrawer(handle, triggerVariantId, parentId = null, via = null) {
  parentProductId = parentId;
  quickVia = via;
  paintCode = '';
  paintIndex = -1;
    // Set header info immediately if available from card data
    // (will be updated after fetch)

    /* 25.09.2026: вікно відкривається один раз, уже заповненим. Раніше
       спершу зʼявлялось вікно зі спінером, а за мить воно різко міняло
       висоту під варіанти. */
    ensurePop();
    try {
      productData = await loadProduct(handle);

      // Header
      titleEl.textContent  = productData.title;
      /* 25.09.2026: за замовчуванням цивільна ціна, як на решті сайту. */
      const civil = v => !(v.options || []).some(o => /Оборон/.test(o));
      const firstVariant = productData.variants.find(v => v.available && civil(v)) || productData.variants.find(v => v.available) || productData.variants[0];
      priceEl.textContent = formatMoney(firstVariant.price);
      /* 25.09.2026: для Adaptis Amulet нове фото з товару (ADAPTIS_ASSETS.amulet). */
      const amuletImg = handle === 'service-adaptis-amulet-starlink' && (window.ADAPTIS_ASSETS || {}).amulet;
      if (amuletImg) { imageEl.src = amuletImg; imageEl.dataset.forHandle = handle; }
      /* Фото з картки каталогу вже завантажене: лишаємо його, щоб не блимало. */
      else if (imageEl.dataset.forHandle !== handle || !imageEl.getAttribute('src') || !imageEl.getAttribute('src').trim()) {
        imageEl.src = productData.featured_image
          ? productData.featured_image.replace(/(\.\w+)$/, '_56x56_crop_center$1')
          : '';
        imageEl.dataset.forHandle = handle;
      }
      imageEl.alt = productData.title;

      // Pre-select: try to match the variant that was on the card
      let triggerVariant = productData.variants.find(v => v.id == triggerVariantId);
      /* Картка каталогу передає свій варіант; якщо він для Сил Оборони, а
         цивільний є в наявності, відкриваємо з цивільною ціною. */
      if (triggerVariant && !civil(triggerVariant) && civil(firstVariant) && firstVariant.available) triggerVariant = firstVariant;
      if (triggerVariant) {
        selectedOptions = [...triggerVariant.options];
      } else {
        // Select first available variant
        const firstAvail = firstVariant;
        selectedOptions = [...firstAvail.options];
      }

      renderOptions();
      updateSubmitState();
      showContent();
      openDrawer();
      prefetchFor(productData.id, productData.handle);
      return true;

    } catch (err) {
      console.error('[QuickBuy] Failed to load product:', err);
      closeDrawer();
      return false;
    }
  }

  // ─── Submit ──────────────────────────────────────────────────────────────────

  function setSubmitText(state) {
    const map = {
      default : submitBtn.dataset.textDefault,
      loading : submitBtn.dataset.textLoading,
      added   : submitBtn.dataset.textAdded,
      error   : submitBtn.dataset.textError,
    };
    submitBtn.textContent = map[state] || map.default;
  }

  document.getElementById('qb-form').addEventListener('submit', async e => {
    e.preventDefault();

    const variantId = variantInp.value;
    if (!variantId) return;

    submitBtn.disabled = true;
    submitBtn.classList.remove('is-added', 'is-error');
    setSubmitText('loading');
    pageBusy(true);

    try {
      const cartItem = {
  id: parseInt(variantId, 10),
  quantity: 1
};

/* 25.09.2026: «В колір авто»: код фарби властивістю позиції, як у конструкторі. */
if (paintIndex >= 0 && isPaint(selectedOptions[paintIndex])) {
  cartItem.properties = Object.assign({}, cartItem.properties, {
    'Код кольору кузова': paintCode.trim() || 'уточнити з менеджером'
  });
}

if (
  productData?.handle === 'service-adaptis-amulet-starlink' &&
  parentProductId
) {
  cartItem.properties = {
    _bundle_parent: String(parentProductId)
  };
}

/* 26.09.2026: джерело позиції для аналітики: вікно швидкої покупки. */
const via = quickVia; quickVia = null;
if (window.AdaptisSrc) window.AdaptisSrc.next = via ? via.src : 'quickbuy';
const variant = findVariant();
const adding = fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  body: JSON.stringify(cartItem),
}).then(r => r.json().then(d => { if (!r.ok) throw new Error(d.description || d.message || ''); return d; }))
  /* 28.09.2026: подія лише після успішного додавання. */
  .then(d => { if (window.AdaptisSrc) window.AdaptisSrc.track(via ? via.ev : 'quickbuy_add'); return d; });

      /* 28.09.2026: «Додано в кошик» відкривається одразу, ще до відповіді
         Shopify, з назвою, фото й ціною обраного варіанта; це вікно
         закривається в ту ж мить. Відмову Shopify пояснює вікно кошика. */
      const pid = productData && productData.id, ph = productData && productData.handle;
      const vImg = variant && variant.featured_image && (variant.featured_image.src || variant.featured_image);
      const shownImg = imageEl && imageEl.dataset.forHandle === ph && !vImg ? (imageEl.currentSrc || imageEl.src) : '';
      showAdded(pid, ph, null, {
        adding: adding,
        preview: [{ variant_id: parseInt(variantId, 10), product_id: pid, handle: ph,
          title: (productData && productData.title || '') + (variant && variant.title && variant.title !== 'Default Title' ? ', ' + variant.title : ''),
          image: vImg || (productData && productData.featured_image) || '', image_exact: shownImg,
          line_price: variant ? variant.price : 0, quantity: 1 }],
        onOpen: () => {
          closeDrawer();
          submitBtn.disabled = false;
          setSubmitText('default');
        },
        onFail: () => {}
      });

    } catch (err) {
      console.error('[QuickBuy] Add to cart failed:', err);
      pageBusy(false);
      setSubmitText('error');
      submitBtn.classList.add('is-error');
      submitBtn.disabled = false;
      setTimeout(() => {
        submitBtn.classList.remove('is-error');
        setSubmitText('default');
      }, 2500);
    }
  });

  // ─── Update cart count bubble ─────────────────────────────────────────────

  /* 28.09.2026: кошик, який вікно вже отримало, без ще одного /cart.js. */
  async function updateCartCount(known) {
    try {
      const cart = known && known.items ? known : await (await fetch(`/cart.js?t=${Date.now()}`, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })).json();

      document.querySelectorAll('[data-testid="cart-bubble"], .cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.remove('hidden', 'visually-hidden');
      });

      const cartBubble = document.querySelector('.cart-bubble');
      if (cartBubble) {
        cartBubble.removeAttribute('hidden');
        cartBubble.classList.remove('visually-hidden');
        cartBubble.style.display = '';
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (e) {
      // non-critical
    }
  }

  // ─── Quick-add directly (no variants needed) ──────────────────────────────

  async function quickAddDirect(variantId, btn) {
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.textLoading || ' ';

    try {
      if (window.AdaptisSrc) { window.AdaptisSrc.next = 'quickbuy'; window.AdaptisSrc.track('quickbuy_add'); }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!res.ok) throw new Error('Cart error');

      btn.textContent = btn.dataset.textAdded || ' ';
      updateCartCount();

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);

    } catch (e) {
      btn.textContent = btn.dataset.textError || ' ';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }
  }

  // ─── Hook into product cards ──────────────────────────────────────────────
  // Uses data-qb-trigger on <button type="button">: no <form>, no submit conflict

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-qb-trigger]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle      = btn.dataset.handle;
    const variantId   = btn.dataset.variant;
    const hasVariants = btn.dataset.hasVariants === 'true';

    if (!variantId) return;

    if (hasVariants && handle) {
      initDrawer(handle, variantId);
    } else {
      quickAddDirect(variantId, btn);
    }
  }, true); // useCapture: спрацьовує до будь-якого stopPropagation

  // ─── Public API (optional) ───────────────────────────────────────────────
  window.AdaptisQuickBuy = { open: initDrawer, close: closeDrawer, added: showAdded, preload: ensurePop, prefetch: prefetchFor, busy: pageBusy };

})();